export function generateAccordionId() {
	const time = new Date().getTime();
	const random = Math.random().toString(36).substring(2, 5);
	return `ckeditor5-accordion-${time}-${random}`;
}

function isLocalStorageAvailable() {
	try {
		const testKey = '__storage_test__';
		localStorage.setItem(testKey, testKey);
		localStorage.removeItem(testKey);
		return true;
	} catch (e) {
		return false;
	}
}

export function setAccordionState(accordionId, isOpen) {
	if (isLocalStorageAvailable()) {
		try {
			localStorage.setItem(`${accordionId}-state`, isOpen ? 'open' : 'closed');
		} catch (error) {
			console.warn(`Could not save accordion state: ${error}`);
		}
	} else {
		console.warn('LocalStorage is not available.');
	}
}

export function getAccordionState(accordionId) {
	if (isLocalStorageAvailable()) {
		try {
			return localStorage.getItem(`${accordionId}-state`);
		} catch (error) {
			console.warn(`Could not retrieve accordion state: ${error}`);
			return null;
		}
	} else {
		console.warn('LocalStorage is not available.');
		return null;
	}
}
